// Each Freeform form must post to its own Account Engagement form handler,
// otherwise submissions are attributed to the wrong AE form and campaign.
const AE_FORM_HANDLERS = {
  newsletterSubscribeFormGlobal: 'https://info.aidian.eu/l/1094132/2026-02-19/35gh87',
};

export default function accountEngagement() {
  document.addEventListener('freeform-ajax-success', function (event) {
    const form = event.form;
    const handlerUrl = form && AE_FORM_HANDLERS[form.dataset.handle];
    if (!handlerUrl) {
      return;
    }

    const getValue = (name) => {
      const field = form.querySelector(`[name="${name}"]`);
      return field ? field.value : '';
    };
    const consentField = form.querySelector('[name="marketingConsent"]');
    const emailValue = getValue('email');

    // Only bridge forms that actually ask for marketing consent and an email
    if (!consentField || !emailValue) {
      return;
    }

    const fields = {
      email: emailValue,
      firstName: getValue('firstName'),
      lastName: getValue('lastName'),
      marketingConsent: consentField.checked ? 'true' : 'false',
    };

    const iframe = document.createElement('iframe');
    iframe.name = 'ae-bridge';
    iframe.style.display = 'none';
    document.body.appendChild(iframe);

    const bridge = document.createElement('form');
    bridge.method = 'POST';
    bridge.action = handlerUrl;
    bridge.target = 'ae-bridge';
    bridge.style.display = 'none';

    Object.keys(fields).forEach((name) => {
      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = name;
      input.value = fields[name];
      bridge.appendChild(input);
    });

    document.body.appendChild(bridge);
    bridge.submit();
  });
}
